import React from 'react';
import PropTypes from 'prop-types';

import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';

import MONTHS from '../../../shared/months.js';
import FormatDollarAmount from '../FormatDollarAmount.jsx';
import GrossTieredCell from './GrossTieredCell.jsx';

function CommGrossMonthlyGrossSalesRow({ grossSale }) {
  const categoryLabel =
    grossSale.category === 'Total' ? 'Total' : String(grossSale.category || '').toUpperCase();
  const isTotal = grossSale.category === 'Total';
  const monthEntries = React.useMemo(
    () =>
      MONTHS.reduce((entries, month) => {
        const amount = Number(grossSale[month] || 0);
        const previousCumulativeGross = entries.at(-1)?.cumulativeGross ?? 0;

        return [
          ...entries,
          {
            month,
            amount,
            cumulativeGross: previousCumulativeGross + amount,
          },
        ];
      }, []),
    [grossSale]
  );

  return (
    <TableRow>
      <TableCell data-cy={`monthly-gross-sales-category-${grossSale.category}`}>
        {categoryLabel}
      </TableCell>
      {monthEntries.map(({ month, amount, cumulativeGross }) => (
        <GrossTieredCell
          key={month}
          amount={amount}
          cumulativeBasis={cumulativeGross}
          tier2Start={Number(grossSale.tier2Start || 0)}
          tier3Start={Number(grossSale.tier3Start || 0)}
          isTotal={isTotal}
          dataCy={`monthly-gross-sales-${month}-${categoryLabel}`}
        />
      ))}
      <TableCell data-cy={`monthly-gross-sales-total-${grossSale.category}`}>
        <FormatDollarAmount amount={grossSale.total} />
      </TableCell>
    </TableRow>
  );
}

CommGrossMonthlyGrossSalesRow.propTypes = {
  grossSale: PropTypes.shape({
    category: PropTypes.string.isRequired,
    tier2Start: PropTypes.number,
    tier3Start: PropTypes.number,
    total: PropTypes.number.isRequired,
  }).isRequired,
};

export default React.memo(CommGrossMonthlyGrossSalesRow);
